const ExtensionByMimeType: Record<string, string> = {
  'image/jpeg': '.jpg',
  'image/png': '.png',
}

// 知らない・空の type は .jpg にする。uploadIdentificationImage が Content-Type を
// file.type || 'image/jpeg' で送るのに揃える
export const extensionForMimeType = (mimeType: string): string => ExtensionByMimeType[mimeType.toLowerCase()] ?? '.jpg'

// ここで拡張子を中身に合わせておかないと、S3 のキーが `xxx.heic` のまま Content-Type: image/jpeg で上がる
export const replaceExtension = (fileName: string, extension: string): string => {
  const dotIndex = fileName.lastIndexOf('.')
  // 先頭のドット（`.heic` のような拡張子だけの名前）は区切りとして扱わない
  if (dotIndex <= 0) {
    return `${fileName}${extension}`
  }
  return `${fileName.slice(0, dotIndex)}${extension}`
}

export const renameToMatchBlob = (fileName: string, blob: Blob): string => replaceExtension(fileName, extensionForMimeType(blob.type))

/**
 * S3 のキーに入れても壊れないファイル名にする。
 * ゲストが選んだファイルの名前がそのままキーになるため、`#` や `?` が入ると
 * 施設側でこのキーから URL を組み立てたときに途中で切れる。
 */
export const toSafeFileName = (fileName: string): string => {
  const dotIndex = fileName.lastIndexOf('.')
  // 先頭のドットは拡張子の区切りとして扱わない（`replaceExtension` と同じ扱い）
  const hasExtension = dotIndex > 0
  const base = hasExtension ? fileName.slice(0, dotIndex) : fileName
  const extension = hasExtension ? fileName.slice(dotIndex + 1) : ''
  const safeBase = base.replace(/[^A-Za-z0-9._-]/g, '_').slice(0, 60) || 'image'
  const safeExtension = extension.replace(/[^A-Za-z0-9]/g, '')
  return safeExtension ? `${safeBase}.${safeExtension}` : safeBase
}
